import { ConversionRateText, ConversionRateWrapper, Input } from "./Styled";

export const ConversionRateField = ({ onChange, material, disabled }: any) => {

    const handleChange = (e: any) => {
        const value = e.target.value;
        const isNumber = /^\s*-?\d*\.?\d*\s*$/.test(value);

        if (isNumber || value === "") {
            onChange(value);
        }
    };

    if (material?.measurement_unit && material?.secondary_measurement_unit) {
        return (
            <ConversionRateWrapper>
                <ConversionRateText>
                    1 {material?.secondary_measurement_unit} =
                </ConversionRateText>
                <Input
                    placeholder="Vui lòng nhập"
                    type="text"
                    disabled={disabled}
                    value={material?.conversion_rate || ""}
                    onChange={handleChange}
                />
                <ConversionRateText>
                    {material?.measurement_unit}
                </ConversionRateText>
            </ConversionRateWrapper>
        )
    }

    return (
        <ConversionRateWrapper style={{width: '100%', justifyContent: 'center'}}>
            <ConversionRateText disabled>
                Vui lòng chọn đơn vị chính và đơn vị phụ để thiết lập tỉ lệ chuyển đổi.
            </ConversionRateText>
        </ConversionRateWrapper>
    );
}